module.exports = "<div fxFlexFill fxLayoutAlign=\"center center\" class=\"icon-pointer\">\n  <mat-icon>delete</mat-icon>\n</div>\n"